import Stories from "./components/Stories.vue";

export default Stories;
